import { apiProvider } from '../utilities/provider';
import { ApiUrlConstants } from './apiUrl.constants';

export const deviceService = {
    getDeviceByUUID
};

function getDeviceByUUID(uuid) {
    return apiProvider.fetch.getSingle(ApiUrlConstants.AccessControl.DeviceUUIDEndPoint, "/" + uuid, true);
}